import { Avatar as MUIAvatar } from '@mui/material';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import classes from './Avatar.module.scss';
import AvatarSkeleton from './AvatarSkeleton';

export interface AvatarProps {
  image?: string;
  title?: string;
  subtitle?: string;
  role?: string;
  showTitles?: boolean;
  imageSize?: number;
  className?: string;
  endIcon?: ReactNode;
  onClick?: () => void;
  loading?: boolean;
}

const Avatar: FC<AvatarProps> = ({
  image,
  title,
  subtitle,
  role,
  showTitles = true,
  imageSize = 40,
  className,
  endIcon,
  onClick,
  loading = false,
}) => {
  return (
    <div
      onClick={!loading ? onClick : null}
      style={onClick && !loading ? { cursor: 'pointer' } : null}
      className={classNames(classes.Container, className)}
    >
      {!loading ? (
        <>
          <MUIAvatar
            src={image}
            alt={title}
            sx={{
              height: imageSize,
              width: imageSize,
              fontSize: `${imageSize / 2}px`,
            }}
          >
            {title?.trim()?.split(' ').length > 1
              ? `${title?.split(' ')?.[0]?.[0]?.toUpperCase()}${title
                  ?.split(' ')?.[1]?.[0]
                  ?.toUpperCase()}`
              : title
              ? title[0]?.toUpperCase()
              : ''}
          </MUIAvatar>
          {showTitles && (
            <div>
              <p>
                {title}
                {role && <span>{` (${role})`}</span>}
              </p>
              {subtitle ? <p>{subtitle}</p> : null}
            </div>
          )}
          {endIcon && <div>{endIcon}</div>}
        </>
      ) : (
        <AvatarSkeleton />
      )}
    </div>
  );
};

export default Avatar;
